/**
 * Leitura de planilha CSV: a volta do `paraCsv`. Aceita o que o Excel e o
 * Google Planilhas exportam — ponto e virgula ou virgula (detectado pela
 * primeira linha), aspas com aspas duplicadas dentro, quebra de linha dentro de
 * aspas, CRLF ou LF, e o BOM do UTF-8.
 */
export function lerCsv(texto: string): string[][] {
  const t = texto.replace(/^﻿/, '');
  const primeira = t.split(/\r?\n/, 1)[0] ?? '';
  const separador = (primeira.match(/;/g)?.length ?? 0) >= (primeira.match(/,/g)?.length ?? 0) ? ';' : ',';

  const linhas: string[][] = [];
  let linha: string[] = [];
  let celula = '';
  let aspas = false;
  for (let i = 0; i < t.length; i++) {
    const c = t[i]!;
    if (aspas) {
      if (c === '"' && t[i + 1] === '"') {
        celula += '"';
        i++;
      } else if (c === '"') {
        aspas = false;
      } else {
        celula += c;
      }
    } else if (c === '"') {
      aspas = true;
    } else if (c === separador) {
      linha.push(celula);
      celula = '';
    } else if (c === '\n' || c === '\r') {
      if (c === '\r' && t[i + 1] === '\n') i++;
      linha.push(celula);
      linhas.push(linha);
      linha = [];
      celula = '';
    } else {
      celula += c;
    }
  }
  if (celula !== '' || linha.length) {
    linha.push(celula);
    linhas.push(linha);
  }
  // Linhas totalmente vazias (fim do arquivo, espacos) nao sao dado.
  return linhas.filter((l) => l.some((c) => c.trim() !== ''));
}

/** Primeira linha como cabecalho: cada linha vira { coluna: valor }, com chaves normalizadas. */
export function csvComoObjetos(texto: string): Record<string, string>[] {
  const [cabecalho, ...corpo] = lerCsv(texto);
  if (!cabecalho) return [];
  const chaves = cabecalho.map(normalizarChave);
  return corpo.map((l) => Object.fromEntries(chaves.map((k, i) => [k, (l[i] ?? '').trim()])));
}

/** "Data de Nascimento" -> "data_de_nascimento"; tira acentos. */
export const normalizarChave = (s: string) =>
  s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');

/** "15/03/2019" ou "2019-03-15" -> "2019-03-15". Nulo se nao for uma data valida. */
export function lerData(s: string): string | null {
  const t = s.trim();
  const br = t.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  const iso = t.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  const [a, m, d] = br ? [br[3], br[2], br[1]] : iso ? [iso[1], iso[2], iso[3]] : [];
  if (!a || !m || !d) return null;
  const data = `${a}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
  const dt = new Date(`${data}T00:00:00Z`);
  return Number.isNaN(dt.getTime()) || dt.toISOString().slice(0, 10) !== data ? null : data;
}
